import axios from "axios";

const url = process.env.REACT_APP_URL

export const createOLPN = async (bpId: number) => {
  try {
    const res: any = await axios.post(url + '/olpn/create', {
      bpId: bpId
    })
    return res
  } catch(err) {
    console.log(err)
    return err
  }
}

export const updateOLPN = async (id: string, value: string | undefined, bpId: string) => {
  try {
    const res: any = await axios.post(url + '/olpn/update', {
      id: id,
      olpn: value,
      bpId: bpId
    })
    return res
  } catch(err) {
    console.log(err)
    return err
  }
}

export const getOLPNById = async (id: string) => {
  try {
    const res = await axios.get(url + '/olpn/getById', {
      params: {id: id}
    })
    return res;
  } catch(err) {
    console.log(err)
    return err
  }
}

export const getOlpnList = async (bpId: number, getAll: boolean = false) => {
  try {
    const res = await axios.get(url + '/olpn/listFromBP', {
      params: {bpId: bpId, getAll: getAll}
    })
    return res;
  } catch(err) {
    console.log(err)
    return err
  }
}

export const getCurrentOLPN = async (bpId: number) => {
  try {
    const res = await axios.get(url + '/olpn/currentOLPN', {
      params: {bpId: bpId}
    })
    return res
  } catch(err) {
    console.log(err)
    return err
  }
}

export const setCurrentOLPN = async (bpId: number, olpnId: string) => {
  try {
    const res = await axios.post(url + '/olpn/setCurrentOLPN', {
      bpId: bpId,
      id: olpnId
    })
    return res
  } catch(err) {
    console.log(err)
    return err
  }
}

export const createAndClose = async (bpId: number, olpn: string) => {
  try {
    const res = await axios.post(url + '/olpn/createAndClose', {
      bpId: bpId,
      olpn: olpn
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export const getOlpnCount = async (OLPNId: string) => {
  try {
    const res = await axios.get(url + '/olpn/getCurrentCount', {
      params: {
        OLPNId: OLPNId
      }
    })
    if (res?.data)
      return res.data
    else return res
  } catch(err) {
    console.log(err)
    return err
  }
}